import { ApprovalRequestType, ESignApproval } from '../../../data/types.generated';
import { ApprovalsAppListItem } from '../../../views/components';
import { getListItemFromESignApproval } from './getListItemFromESignApproval';

/**
 * Converts data from syntex http request to an array of ApprovalsListItems that the UI can consume.
 *
 * @param approvals array of ESignApprovals
 * @param approvalType ApprovalRequestType
 * @param currentUserId Current user id
 * @returns array of ApprovalsAppListItem[]
 */
export const convertESignDataToApprovalsListItems = (
    approvals: ESignApproval[],
    approvalType: ApprovalRequestType,
    currentUserId: string
): ApprovalsAppListItem[] => {
    if (!approvals) {
        return [];
    }

    return approvals.map(
        (entry: ESignApproval): ApprovalsAppListItem => getListItemFromESignApproval(entry, approvalType, currentUserId)
    );
};
